import { Data } from '../signup-data/DATA';
import { getRecommendedHubletResponse } from '../store/http-responses/selectors';
import { getSignupDataSkipped, getSignupDataValue } from '../store/signup-data/selectors';
import { Step } from '../views/Step';
export const getPropertiesToTrack = state => {
  const wasOptionalPhoneNumberStepSkipped = getSignupDataSkipped(state, Data.OptionalPhoneNumber);
  const hubletResponse = getRecommendedHubletResponse(state);
  const recommendedHublet = hubletResponse ? hubletResponse.region : null;
  const hublet = getSignupDataValue(state, Data.HubletSelection);
  return {
    [Step.OptionalPhoneNumber]: {
      isSkipped: wasOptionalPhoneNumberStepSkipped
    },
    [Step.HubletSelection]: {
      isUsingHubletRecommendation: hublet === recommendedHublet
    }
  };
};